const theme = {
  colors: {
    background: '#F9FAFB',
    surface: '#FFFFFF',
    primary: '#012442',
    primarySoft: 'rgba(1, 36, 66, 0.08)',
    primaryBorder: 'rgba(1, 36, 66, 0.12)',
    textPrimary: '#1E2124',
    textSecondary: 'rgba(30, 33, 36, 0.72)',
    highlight: '#FF3100',
    highlightSoft: 'rgba(255, 49, 0, 0.10)',
    white: '#FFFFFF',
  },
  typography: {
    fontFamily:
      "'Airbnb Cereal VF', 'Circular', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif",
    weightRegular: 400,
    weightSemibold: 600,
    weightBold: 700,
    titleSize: '1rem',
    titleLineHeight: '1.25rem',
    bodySize: '0.875rem',
    bodyLineHeight: '1.25rem',
    captionSize: '0.75rem',
    captionLineHeight: '1rem',
    letterSpacing: 'normal',
  },
  spacing: {
    xxs: 4,
    xs: 8,
    sm: 12,
    md: 16,
    lg: 24,
    xl: 32,
  },
  radius: {
    small: 8,
    medium: 12,
    large: 16,
  },
  elevation: {
    base: '0px 3px 3px rgba(0,14,51,0.25), 0px 1px 2px rgba(0,14,51,0.25)',
  },
  motion: {
    transition: 'all 0.2s cubic-bezier(0.2, 0, 0, 1)',
    iconTransition: 'transform 0.1s cubic-bezier(0.2, 0, 0, 1)',
  },
};

export default theme;